import { Pill } from 'ypf-pas-general-ui-components';

import { estadosSds } from './dataStatus';

export const toArrEnum = (paramValue, objeto, selectName) => {
  const arrNum = [];

  if (paramValue) {
    const arr = paramValue.split(',');

    if (objeto) {
      arr.forEach((value) => {
        const valObj = selectName.filter((obj) => obj.id === Number(value));

        arrNum.push({
          id: Number(value),
          nombre: valObj[0].nombre,
          value: Number(value),
          label: valObj[0].nombre
        });
      });
    } else {
      arr.forEach((value) => {
        arrNum.push(Number(value));
      });
    }

    return arrNum;
  }

  return arrNum;
};

export const setParams = (params, history, urlP) => {
  let url = urlP || `?`;
  const keys = Object.keys(params);

  keys.forEach((k) => {
    if (params[k] && typeof params[k] === 'object' && !Array.isArray(params[k])) {
      url = setParams(params[k], history, url);
    } else {
      url = url.concat(`${url.length > 1 ? '&' : ''}${k}=${params[k] || ''}`);
    }
  });

  return url;
};

export const cellEstado = ({ value, row }) => {
  const tratadas = row.original?.sdmdTratadas || 0;
  const totales = row.original?.sdmdTotales || 0;
  const error = row.original?.sdmdError || 0;
  const estado = estadosSds.find((item) => item.id === value);

  if (tratadas !== totales && estado.estado === 'Tratado') {
    return (
      <Pill
        error={error > 0}
        label={`${estado.estado} ${tratadas}/${totales}`}
        textColour="success"
        variant="light"
      />
    );
  }

  return <Pill label={estado.estado} variant={estado.color} />;
};

// generates random id;
export const getRandomAndUniqueKey = () => {
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);

  // return id of format 'aaaaaaaa'-'aaaa'-'aaaa'-'aaaa'-'aaaaaaaaaaaa'
  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};
export const getUrlWithSessionCreds = (url) => {
  const accessToken = localStorage.getItem('access_token');
  const accessTokenDate = localStorage.getItem('access_token_date');
  const refreshToken = localStorage.getItem('refresh_token');
  const expiresIn = localStorage.getItem('access_token_expires_in');

  let atd = accessTokenDate;

  if (accessTokenDate) {
    // The concat is needed because this value in certifications
    // includes three additional leading zeros
    atd = accessTokenDate.length === 10 ? accessTokenDate.concat('000') : accessTokenDate;
  }

  const searchParams = new URLSearchParams();

  searchParams.append('at', accessToken);
  searchParams.append('atd', atd);
  searchParams.append('rt', refreshToken);
  searchParams.append('ei', expiresIn);

  return `${url}?${searchParams.toString()}`;
};

export const firstUpperLetter = (word) => {
  const singleWords = word.split(' ');

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < singleWords.length; i++) {
    const firstLetter = singleWords[i].charAt(0).toUpperCase();
    const restOfWord = singleWords[i].slice(1).toLowerCase();

    singleWords[i] = firstLetter + restOfWord;
  }

  return singleWords.join(' ');
};

/**
 * Returns true if the given string is a valid date. e.g '2023-04-20'
 * @param {string} date yyyy-mm-dd
 * @returns {boolean}
 */
export const isStringValidDate = (date) => {
  const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;

  if (!dateFormatRegex.test(date)) return false;

  const [year, month, day] = date.split('-');

  const dateInstance = new Date(year, month - 1, day);

  return (
    dateInstance.getFullYear() === +year &&
    dateInstance.getMonth() === +month - 1 &&
    dateInstance.getDate() === +day
  );
};

/**
 * @param {Function} fn The function to be throttled.
 * @param {number?} delay The time interval in milliseconds. Default 500ms.
 * @returns {Function} The throttled function.
 */
export const throttle = (fn, delay = 500) => {
  let timerID;
  let lastExecutedTime = 0;

  return (...args) => {
    const currentTime = Date.now();

    if (currentTime - lastExecutedTime >= delay) {
      fn.apply(this, args);
      lastExecutedTime = currentTime;
    } else {
      clearTimeout(timerID);

      timerID = setTimeout(() => {
        fn.apply(this, args);
        lastExecutedTime = Date.now();
      }, delay - (currentTime - lastExecutedTime));
    }
  };
};

export const tryCatchMaker = async ({ promise, defaultValue, setNewToast }) => {
  // * This fn puts the promise inside a try catch that handles the error and returns a default value.
  try {
    const response = await promise();

    return response;
  } catch (error) {
    setNewToast({
      type: 'ERROR',
      message: error.message
    });

    return defaultValue;
  }
};
